import React from 'react'
import toast from "react-hot-toast";
import { useCartContext } from '../context/cart_context';
import CartQuantityToggle from './CartQuantity'
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../styles/Button';
import styled from 'styled-components'


const AddtoCart = ({products,  isLoggedIn }) => {
  const productArray = Array.isArray(products) ? products : [products];
  const {addToCart}=useCartContext();
  const navigate = useNavigate();

   const [quantity,setQuantity]=useState(1);

    const setDecrease=()=>{
       quantity>1 ? setQuantity(quantity-1) :setQuantity(1);
    };
    const setIncrease=()=>{
        setQuantity(quantity+1)
    };
    const updateQuantity = (newQty) => {
    if (newQty > 0) setQuantity(newQty);  
    };

    const handleAddToCart = (curElem) => {
     const { _id, SKU, price, Item, main } = curElem; 

      if (isLoggedIn) {
        addToCart(_id, SKU, price, Item, main, quantity, productArray);
         toast.success("Item added to cart!");
        //navigate('/cart');
        setTimeout(() => navigate('/cart'), 500); 
      } 
      else {
        toast.error("Please login to add items to cart !");
        navigate('/username', { state: { from: '/cart' } });
      }
    };
  
   
  return (
    <Wrapper>      
        <CartQuantityToggle
            quantity={quantity}
            setDecrease={setDecrease}
            setIncrease={setIncrease}
            updateQuantity={updateQuantity}
        />

      {productArray.map((curElem, index) => (
        <Button 
        className='addToCart'
        key={index} 
        onClick={() => handleAddToCart(curElem)}>
          Add to Cart
        </Button>
      ))}
       
    </Wrapper>
  
  )
}
const Wrapper = styled.section`
  
  .Quantity-toggle {
    margin-top: 1rem;    
    padding: 1rem;


    .Quantity-style {
      color: ${({ theme }) => theme.colors.font};
      padding: 0.5rem ;
      margin-bottom: 1rem;
      
      }
    }
  @media (max-width: ${({ theme }) => theme.media.mobile}) {
    .addToCart{
    margin-left: 3rem;
    }  
}
`;

export default AddtoCart
